import liverpoolLogo from "./LIVERPOOL.svg";

const obj = {
  liverpoolLogo,
};

export default obj;
